import React from 'react';
import { StudentStopsReport } from '../types';
import { PaperWrapper } from '../../common/styled';
import { DataGrid } from '@mui/x-data-grid';
import { dataGridSx } from '../../common/styled/DataGrid';
import pallet from '../../../layouts/pallet';
import { getStudentTransportReportColumns } from '../utils/studentTransportReportColumn';
import CustomDataGridToolbar from '../../common/components/CustomDataGridToolbar';

const StudentTransportReportTable = ({
  studentTransportData
}: {
  studentTransportData: StudentStopsReport[];
}) => {
  const columns = getStudentTransportReportColumns();
  return (
    <PaperWrapper>
      <DataGrid
        rowHeight={50}
        rows={studentTransportData}
        columns={columns}
        disableRowSelectionOnClick
        pageSizeOptions={[5, 10, 25]}
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize: 10 }
          },
          columns: {
            ...columns,
            columnVisibilityModel: { id: false }
          }
        }}
        showToolbar
        slots={{ toolbar: CustomDataGridToolbar }}
        slotProps={{
          toolbar: {
            printOptions: { disableToolbarButton: true },
            showQuickFilter: true
          }
        }}
        sx={{
          ...dataGridSx(pallet),
          '& .MuiDataGrid-virtualScroller': {
            overflowY: 'auto'
          }
        }}
      />
    </PaperWrapper>
  );
};

export default StudentTransportReportTable;
